module.exports = __webpack_public_path__ + "static/media/mail-icon.805de1cc.svg";